import { useMemo } from 'react';

import { Locale } from 'chaika-enums';
import { MeatballButtonMenuItem } from '../MeatballButton';
import { authUserService } from '@store/AuthUser/services/authUserService';

import type { StoreState } from '@store';
import { getKeyByValue } from '@utils/getKeyByValue';
import { assertIsDefined } from '@utils/assertIsDefined';
import { ChangeLanguageAttributes } from 'chaika-test-attributes';

const LanguagesDic = {
    [Locale.Ru]: 'Русский',
    [Locale.Am]: 'հայերեն',
    [Locale.En]: 'English',
    [Locale.Ge]: 'ქართული',
    [Locale.Pt]: 'Português',
};

export function useChangeLanguage({ authUser }: StoreState) {
    const locale = authUser.selectedLanguage ?? Locale.Ru;
    const language = useMemo(() => LanguagesDic[locale], [locale]);

    const handleLanguageChange = async (lang: string) => {
        const newLocale = getKeyByValue(LanguagesDic, lang);
        assertIsDefined(newLocale, `Language ${lang} is picked from the languages menu`);

        if (newLocale !== authUser.selectedLanguage) {
            await authUserService.updateUserLang(newLocale);

            window.location.reload();
        }
    };

    const makeMeatballItems = (): MeatballButtonMenuItem[] => {
        return [
            {
                value: LanguagesDic[Locale.Ru],
                label: LanguagesDic[Locale.Ru],
                dataTest: ChangeLanguageAttributes.ChangeToRussian,
                onClick: handleLanguageChange,
            },
            {
                value: LanguagesDic[Locale.En],
                label: LanguagesDic[Locale.En],
                dataTest: ChangeLanguageAttributes.ChangeToEnglish,
                onClick: handleLanguageChange,
            },
            {
                value: LanguagesDic[Locale.Ge],
                label: LanguagesDic[Locale.Ge],
                dataTest: ChangeLanguageAttributes.ChangeToGeorgian,
                onClick: handleLanguageChange,
            },
            {
                value: LanguagesDic[Locale.Am],
                label: LanguagesDic[Locale.Am],
                onClick: handleLanguageChange,
            },
            {
                value: LanguagesDic[Locale.Pt],
                label: LanguagesDic[Locale.Pt],
                onClick: handleLanguageChange,
            },
        ];
    };

    return {
        language,
        makeMeatballItems,
        locale: locale.toUpperCase(),
    };
}
